import { FieldRow, Input, Textarea } from '@platform/design-system';
import type { ReactNode } from 'react';
import { AreaFields } from '../geography/AreaFields.tsx';
import type { Geography } from '../geography/useGeoAreas.ts';
import { usePageContext } from '../usePageContext.ts';
import { ORDER_FORM_LIMITS } from './new-order-form.ts';
import type { OrderFormState } from './OrderForm.tsx';

export type DeliveryFieldsProps = { form: OrderFormState; geography: Geography; depot?: ReactNode };

export const DeliveryFields = ({ form, geography, depot }: DeliveryFieldsProps) => {
  const { t } = usePageContext();
  const { errors } = form.formState;
  return (
    <>
      <Textarea
        label={t('orders.address')}
        required
        maxLength={ORDER_FORM_LIMITS.address}
        errorText={errors.address ? t('newOrder.addressRequired') : undefined}
        {...form.register('address')}
      />
      <AreaFields
        form={form}
        geography={geography}
        by="code"
        governorate="governorate"
        delegation="delegation"
        labels={{ governorate: t('orders.governorate'), delegation: t('orders.delegation') }}
        required
        governorateError={errors.governorate ? t('newOrder.governorateRequired') : undefined}
      />
      <FieldRow>
        <Input
          label={t('orders.postalCode')}
          inputMode="numeric"
          autoComplete="postal-code"
          maxLength={ORDER_FORM_LIMITS.postalCode}
          {...form.register('postalCode')}
        />
        {depot}
      </FieldRow>
    </>
  );
};
